/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { G2StateTokenDto } from '../models/G2StateTokenDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class G2Service {

    /**
     * Get G2 state token
     * @returns G2StateTokenDto Successfully retrieved G2 state token
     * @throws ApiError
     */
    public static getStateToken(): CancelablePromise<G2StateTokenDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/g2/state-token',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
